// extracted by mini-css-extract-plugin
module.exports = {"container":"e_ko","placeholder":"e_lo","embed":"e_mo"};